












import { Component, Prop, Vue, PropSync } from 'vue-property-decorator';

@Component
export default class AuthResendBtn extends Vue {
  @Prop() readonly resend!: () => Promise<any>;
  @PropSync('time') timeSync!: number;

  localTime = 29;

  timer = this.resetTimer();

  isLoading = false;

  get isTimeSyncSet() {
    return this.timeSync || this.timeSync === 0;
  }

  get computedTime() {
    if (this.isTimeSyncSet) {
      return this.timeSync;
    }

    return this.localTime;
  }

  set computedTime(v) {
    if (this.isTimeSyncSet) {
      this.timeSync = v;
    } else {
      this.localTime = v;
    }
  }

  resetTimer() {
    return setInterval(() => {
      if (this.computedTime > 0) {
        this.computedTime -= 1;
      }
    }, 1000);
  }

  handleResendEmail() {
    this.isLoading = true;
    this.resend()
      .then(() => {
        this.computedTime = 29;
        this.isLoading = false;
      })
      .catch(() => {
        this.computedTime = 0;
        this.isLoading = false;
      });
  }
}
